const state = {
  nats: App.nats
};

const getters = {
  getNats: state => state.nats
};

const mutations = {
  setNats: (state, payload) => {
    state.nats = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./resources/js/modules/nats.js